<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: flex-start;align-items: center;">
        <button-add @click="toAddPage1" value="添加" v-if="permissionCodes.indexOf('040005002') !== -1"></button-add>
      </div>
    </div>
    <table-main :hasOperation="false" :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />
  
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%">
      <div class="form-line">
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">账期：</span>
            </div>
              <el-date-picker
              v-model="timevalue"
              style="width:280px"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              />
          </div>
      <div class="form-line">
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">总分摊电量：</span>
            </div>
            <el-input v-model="formData.totalShareElectricity" size="small" style="width: 280px" />
          </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/common/buttons/button-add";
import InputSearch from "../../../components/Input/InputSearch";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/PropertyFee";
import { errorHandler } from "../../../utils/errorHandler";
import { nError, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import ButtonCancel from "../../../components/Button/ButtonCancel";

export default {
  components: {
    ButtonCancel,
    TableMain,
    InputSearch,
    ButtonAdd,
    Breadcrumb
  },
  name: "invoice-power-consumption",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "纳爱斯专属",
          name: "property-fee-management"
        },
        {
          value: "分摊用电费用"
        }
      ],
      tableHead: [
        {
          prop: "cycle",
          label: "账期"
        },
        {
          prop: "totalShareElectricity",
          label: "总分摊电量"
        },
        {
          prop: "addTime",
          label: "添加时间"
        },
        {
          prop: "usedText",
          label: "是否使用"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      requestData: {
        pageSize: 10,
        pageNum: 1
      },
      formData: {},
      timevalue: [],
      dialogVisible: false
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  methods: {
    toAddPage1() {
      this.dialogVisible = true;
    },
    getPage() {
      this.$axios
        .post(api.getShareConfigPage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              if (v.used) {
                v.usedText = "是";
              } else {
                v.usedText = "否";
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    confirm() {
      this.formData.cycle = this.timevalue[0] + " - " + this.timevalue[1];
      console.log(this.timevalue);
      if (this.timevalue.length === 0) {
        nError("请选择账期");
        return false;
      }
      if (!this.formData.totalShareElectricity) {
        nError("请输入总分摊电量");
        return false;
      }
      this.$axios
        .post(api.getUseBillConfig, this.formData)
        .then(res => {
          nSuccess("添加成功");
          this.dialogVisible = false;
          this.formData = {};
          this.timevalue = [];
          this.getPage();
        })
        .catch(errorHandler("添加失败"));
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/PropertyFee/electricityShareFee/invoicePowerConsumption.vue